import { ColumnFieldTitle, OfbizField, OfbizForm,OfbizList, RemoteFormData,FieldSet, Condition } from '@urbannex/ofbiz-forms';
import { CustomContainerItem } from '../custom-container/custom-container-item';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ViewContainersService } from './services/view-containers.service';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { UpdateComponentStoreService } from '../update-component-store.service';

export abstract class BaseComponentConfig{
    breadCrumbs:BreadCrumbData[];
    componentConfig:ComponentConfig;
    options:ConfigOptions;
    baseUrl:string;
    routerParams:ParamMap;
    handleError:any;
    action:ActionState;
    routerData:any;
    selectedRelation:Relation;
    selectedMasterDetail:Relation;
    /**
   * Type from menuItem data object used to resolve the master-detail/relation specified in the context menu
   */
    selectedValueType:string;

    constructor(
        protected viewContainerService:ViewContainersService,
        protected menuService:NbMenuService,
        protected configurationService:ConfigurationService,
        protected route:ActivatedRoute,
        protected router:Router,
        protected updateComponentStoreService:UpdateComponentStoreService){
        this.componentConfig = new ComponentConfig(this.options);
        console.log(this.componentConfig)

    }
    /**
     * Function to generate fields given the name of the form (formName)
     * and FORMS (Array of forms)
     * @param formName 
     * @param FORMS 
     * @returns fields
     */
    getFields(formName:string,FORMS):any[]{
        let fields:any[];
        let columnFieldTitles:ColumnFieldTitle[];
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        if(localForm){
            fields = localForm.fields;
            columnFieldTitles = columnFieldTitles = localForm.columns;
            if(columnFieldTitles != undefined && columnFieldTitles.length > 0){
                //console.log("Found columnFieldTitles");
                fields.forEach(field => {
                    let columnField = columnFieldTitles.find(element => element.name == field.name);
                    if(columnField){
                        //console.log({FoundColumnField:{field:field.name,columnFieldTitle:columnField}})
                        field.title = columnField.title;
                    }
                })
                
            }
        }
        return fields;
    }
    /**
     * @comment Function used to return column titles used in a table
     * @param formName Name of the form to look up
     * @param FORMS Array containing forms for this component
     * @returns columnFieldTitles
     */
    getColumnFieldTitles(formName:string,FORMS:any[]):ColumnFieldTitle[]{
        let columnFieldTitles:any[];
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        if(localForm && localForm.columns){
            columnFieldTitles = localForm.columns;
        }
        console.log({columnFieldTitles:columnFieldTitles,"formName":formName});
        return columnFieldTitles
    }

    getTarget(formName:string,FORMS):string{
        let target = "";
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        target = localForm.target;
        return target;
    }
    getAltTarget(formName:string,FORMS):any[]{
        let altTargets = [];
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        altTargets = localForm.altTarget;
        return altTargets;
    }
    /**
     * 
     * @param formName 
     * @param FORMS 
     * @returns targets object consisting of createTarget and EditTarget
     */
    getTargets(formName:string,FORMS):any{
        let targets = {}
        let form = FORMS.find(form => form.name == formName || form.formName == formName);
        targets = form.targets;
        return targets
    }
    getAppContext(formName:string,FORMS):string{
        let form = FORMS.find(form => form.name == formName || form.formName == formName);
        let appContext = form.appContext || "";
        return appContext
    }
    /**
     * 
     * @param formName 
     * @param FORMS 
     * @returns The field name to be used when creating a title for the form
     */
    getTitleDescriptionField(formName:string,FORMS):string{
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        let fieldName = localForm.titleDescriptionField ? localForm.titleDescriptionField : "";
        return fieldName;
    }
    getIdFieldName(formName:string,FORMS):string{
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        let fieldName = localForm.idFieldName ? localForm.idFieldName : "";
        return fieldName;
    }
    /**
     * Funtion to generate BreadCrumbs given a componentConfig
     * @param componentConfig 
     * @returns array of breadcrumbs
     */
    setBreadCrumbs(componentConfig:ComponentConfig):BreadCrumbData[]{
        let breadCrumbs = [];
        if(componentConfig.breadCrumbData){
          breadCrumbs.push(componentConfig.breadCrumbData);
          if(componentConfig.childComponent && componentConfig.childComponent.breadCrumbData){
            breadCrumbs.push(componentConfig.childComponent.breadCrumbData);
            let childComponentConfig = componentConfig.childComponent;
            if(childComponentConfig.childComponent && childComponentConfig.childComponent.breadCrumbData){
              breadCrumbs.push(childComponentConfig.childComponent.breadCrumbData)
            }
          }
        }
        console.log({breadCrumbsArray:breadCrumbs});
        return breadCrumbs
       }
    
    getFieldSets(formName:string,FORMS):FieldSet[]{
        let fieldSets = [];
        let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
        fieldSets = localForm.fieldSets;
        return fieldSets;
    }
    /**
     * 
     * @returns the baseurl for backend calls
     */
    getBaseUrl():string{
       return this.configurationService.getBaseUrl() 
    }

    resolveParams(routerParams:ParamMap):any{
        return routerParams["params"];
    }

    resolveItem(selectedValue:SelectedValue){
        console.log(selectedValue.event)
        console.log(selectedValue.data)
        let remoteFormData:RemoteFormData = selectedValue.data;
        console.log("Event",selectedValue.event,"FormData",remoteFormData);
        this.updateComponentStoreService.handleMenuItemSelected(selectedValue); 
        //selectedValue.data.appContext
        //selectedValue.data.parameters
    }

    reOrderRelations(relations:Relation[],position:number){
        while (position) {
          [relations[position], relations[position - 1]] = [relations[position - 1], relations[position]];
          position--;
        }
        return relations;
      }
    /**
     * 
     * @param actionState : String representation of the action state
     * @returns actionState : ActionState
     */
    setActionStateFromParam(actionState:string):ActionState{
        let action:ActionState;
        switch(actionState){
            case "add":
                action = ActionState.ADD;
                break;
            case "edit":
                action = ActionState.EDIT;
                break;
            case "delete":
                action = ActionState.DELETE;
                break;
            case "list":
                action = ActionState.LIST;
                break;
            case "view":
                action = ActionState.VIEW;
                break;
            case "test":
                action = ActionState.TEST;
                break;
            case "relate":
                action = ActionState.RELATE;
                break;
            case "link":
                action = ActionState.LINK;
                break;
            case "master-detail":
                action = ActionState.MASTERDETAIL;
                break;
            case "custom":
                action = ActionState.CUSTOM;
                break;
            case "tasks-action-result":
                action = ActionState.TASKSACTRSLT;
                break;
            default:
                action = ActionState.FIND;
        }
        console.log({input:actionState,output:action});
        return action;
    }
    /**
     * 
     * @param options ComfigOptions object that contains the component configuration
     * @param action ActionState enum that represents the action state
     * @returns paths: string[]
     */
    getPaths(options:ConfigOptions,action:ActionState):string[]{
        let paths = [];
        switch(action){
            case ActionState.RELATE:
                paths = options.relations.map(relation => relation.path);
                break;
            case ActionState.MASTERDETAIL:
                paths = options.masterDetails.map(masterDetail => masterDetail.path);
                break;
            case ActionState.TASKSACTRSLT:
                paths = options.tasks.map(task => task.path);
                break;
            default:
                break;
        }
        return paths;
    }
    /**
     *
    * Type from menuItem data object used to resolve the master-detail/relation specified in the context menu
     * @param action Whether it's a list,add,edit,view,delete,relate,link,master-detail,custom or tasks-action-result
     * @param path String from the route url which is used to resolve the selected value type.  The string is compared to the path property of the relation, master-detail object or task object
     * @param options ConfigOptions object that contains the component configuration
     * @returns selectedValueView: any
     */
    setSelectedValueView(action:ActionState,path:string,options:ConfigOptions):any{
        let selectedValueView;
        let relations = options.relations;
        let masterDetails = options.masterDetails;
        let tasks = options.tasks;
        switch (action) {
            case ActionState.RELATE:
                let relation:Relation;
                relation = relations.find(relation => relation.path == path);
                selectedValueView = relation;
                break;
            case ActionState.MASTERDETAIL:
                let masterDetail:Relation;
                masterDetail = masterDetails.find(masterDetail => masterDetail.path == path);
                selectedValueView = masterDetail;
                break
            case ActionState.TASKSACTRSLT:
                let task:ComponentTask;
                task = tasks.find(task => task.path == path);
                selectedValueView = task;
                break
            default:
                break;
        }
        console.log({selectedValueView:selectedValueView});
        return selectedValueView;
    }

}

export enum SelectorType{
    LIST = 'list',
    LOOKUP = 'lookup',
}

export interface TaskSelector{
    title:string;
    type:SelectorType,
    source:OfbizForm | OfbizList
}

export interface UpdateAction{
    title:string;
    isDefault:boolean;
    condition:Condition;
    updateForm:OfbizForm;
}

export interface TaskUpdater {
    title:string;
    updateActions:UpdateAction[]
}

export interface TaskEffect{
    title:string;
    result:OfbizList;
}

export interface ComponentTask{
    title: String;
    path:string;
    selector:TaskSelector;
    updater:TaskUpdater;
    effect:TaskEffect;
}

export interface AssistantCapability {
    type: string;                     // e.g., 'categorize', 'suggest-features', 'generate-description'
    description: string;              // Human-readable description of this capability
    requiredFields?: string[];        // Entity fields required for this capability to function
    optionalFields?: string[];        // Additional entity fields that enhance capability if present
    contextualHint?: string;          // UI hint to show users when this capability is available
  }

  export interface AssistantConfig {
    enabled: boolean;                 // Toggle assistant functionality
    name: string;                     // Display name for the assistant
    path: string;                     // URL path for the assistant
    icon?: string;                    // Optional icon reference
    capabilities: AssistantCapability[]; // What this assistant can do
    contextualTriggers?: {            // Define when assistant should proactively appear
      onCreate?: boolean;             // Show assistant when creating new entity
      onEdit?: boolean;               // Show assistant when editing existing entity
      onFields?: string[];            // Show when these fields are being edited
      onEmpty?: string[];             // Show when these fields are empty
    };
    defaultPrompts?: {                // Pre-configured prompts for common actions
      [key: string]: string;          // e.g., 'suggestCategory': 'Suggest a category for this product'
    };
    uiPosition?: 'sidebar' | 'inline' | 'floating'; // Where to render the assistant UI
    serverEndpoints?: {               // Map capability types to server endpoints
      [capabilityType: string]: string; // e.g., 'categorize': '/api/recommend/category'
    };
  }

export class ComponentConfig{
    name:string;
    title:string;
    standAlone:boolean;
    defaultParameters:any[];
    defaultAction:ActionState;
    idFieldName:string;
    listForm?:OfbizList;
    findForm:OfbizForm;
    addForm:OfbizForm;
    addForms:OfbizForm[];
    listForms:OfbizList[];
    actions:any[];
    settings:any[];
    summaryView:SummaryViewCard[];
    lookUpEndPoint:string;
    searchResults:any;
    breadCrumbData:BreadCrumbData;
    childComponent:ComponentConfig;
    customContainerItems:CustomContainerItem[];
    lookups:Lookup[];
    relations:Relation[];
    selectedRelation:Relation;
    masterDetails:Relation[];
    selectedMasterDetails:Relation;
    appContext:string;
    outGoingLinks:OutGoingLink[];
    tasks:ComponentTask[];
    selectedTask:ComponentTask;
    menuAndTitleOptions:MenuTitleOptions;
    assistant?: AssistantConfig;
    constructor(
        options:{
            name?:string,
            title?:string,
            standAlone?:boolean,
            defaultParameters?:any[],
            defaultAction?:ActionState,
            idFieldName?:string,
            listForm?:OfbizList,
            findForm?:OfbizForm,
            addForm?:OfbizForm,
            addForms?:OfbizForm[],
            listForms?:OfbizList[],
            actions?:any[],
            settings?:any[],
            store?:any,
            summaryView?:SummaryViewCard[],
            lookUpEndPoint?:string,
            searchResults?:any,
            breadCrumbData?:BreadCrumbData,
            childComponent?:ComponentConfig,
            customContainerItems?:CustomContainerItem[],
            lookups?:Lookup[];
            relations?:Relation[];
            selectedRelation?:Relation;
            masterDetails?:Relation[];
            selectedMasterDetails?:Relation;
            appContext?:string;
            tasks?:ComponentTask[];
            selectedTask?:ComponentTask;
            outGoingLinks?:OutGoingLink[];
            menuAndTitleOptions?:MenuTitleOptions;
            assistant?: AssistantConfig;
        }={}){
            this.name = options.name;
            this.title = options.title;
            this.standAlone = options.standAlone ? options.standAlone:false;
            this.defaultParameters = options.defaultParameters;
            this.defaultAction = options.defaultAction;
            this.idFieldName = options.idFieldName;
            this.listForm = options.listForm;
            this.findForm = options.findForm;
            this.addForm = options.addForm;
            this.addForms = options.addForms;
            this.listForms = options.listForms;
            this.actions = options.actions;
            this.settings = options.settings;
            this.summaryView = options.summaryView;
            this.lookUpEndPoint = options.lookUpEndPoint;
            this.searchResults = options.searchResults;
            this.breadCrumbData = options.breadCrumbData;
            this.childComponent = options.childComponent;
            this.customContainerItems = options.customContainerItems;
            this.lookups = options.lookups;
            this.relations = options.relations;
            this.selectedRelation = options.selectedRelation;
            this.masterDetails = options.masterDetails;
            this.selectedMasterDetails = options.selectedMasterDetails;
            this.appContext = options.appContext;
            this.tasks = options.tasks;
            this.selectedTask = options.selectedTask;
            this.outGoingLinks = options.outGoingLinks;
            this.menuAndTitleOptions = options.menuAndTitleOptions
            this.assistant =  options.assistant;
        }
    
    getMenuAndTitleOptions():MenuTitleOptions {
        return this.menuAndTitleOptions;
    }

    setSelectedMasterDetails?(selectedMasterDetails:Relation){
        this.selectedMasterDetails = selectedMasterDetails;
    }

    getSelectedMasterDetails?():Relation{
        return this.selectedMasterDetails;
    }

    setSelectedRelation?(selectedRelation:Relation){
        this.selectedRelation = selectedRelation;
    }

    getSelectedRelation?():Relation{
        return this.selectedRelation;
    }
}

export interface MenuAndTitleOptions {
    path?:string
    menuItems?: NbMenuItem[];
    headerTitle?: string;
    menuTag?:string
  }

export interface MenuTitleOptions{
    path?:string;
    menuItems?:NbMenuItem[];
    headerTitle?:string;
    menuTag?:string
}

export interface Relation{
    /**
     * Title used in menu
     */
    title?:string;
    /**
     * 
     */
    /**
     * Whether this relation's title should be grouped under a title group when menus are created
     */
    titleGroup?:string,
    /**
     * The path fragment from the route url used to select the selected relation
     */
    path?:string,
    addContainerTitle:string;
    listContainerTitle:string;
    detailListContainerTitle?:string;
    entityName?:string;
    keyMap:KeyMap;
    addFormName:string;
    listFormName:string;
    addForm?:OfbizForm;
    listForm?:OfbizList;
    isListDetail?:boolean;
    listDetail?:OfbizList;
    appContext?:string;
    /**
     * Whether the the add form depends on the selected value
     */
    dynamic?:boolean;
    dynamicAddForms?:OfbizForm[];
}

export interface KeyMap{
    fieldName:string;
    relatedFieldName?:string;
}

export interface ConfigOptions{
    name:string;
    title:string;
    defaultParameters?:any[];
    defaultAction?:ActionState;
    idFieldName?:string;
    listForm?:OfbizList;
    findForm:OfbizForm;
    addForm:OfbizForm;
    actions:any[];
    settings:any[];
    summaryView?:SummaryViewCard[],
    lookUpEndPoint?:string,
    searchResults?:any;
    breadCrumbData?:BreadCrumbData;
    childComponent?:ComponentConfig;
    customContainerItems?:CustomContainerItem[];
    lookups?:Lookup[];
    relations?:Relation[];
    selectedRelation?:Relation;
    masterDetails?:Relation[];
    selectedMasterDetails?:Relation;
    appContext?:string;
    outGoingLinks?:OutGoingLink[];
    menuAndTitleOptions?:MenuTitleOptions;
    tasks?:ComponentTask[];
    selectedTask?:ComponentTask;
    assistant?: AssistantConfig;
}

export interface Lookup{
    fieldFormName:string
    findFormName:string;
    resultListName:string;
    requestingField?:OfbizField;
    lookedUpValueFieldName?:string;
    lookedUpValue?:any;
    lookedUpDescritionFieldName?:string;
    lookedUpDescription?:any;
}

export interface SummaryViewCard {
    title?:string;
    entityName?:string;
    order?:number;
    type?:string;
    formName?:string;
    formLocation?:string;
    params?:any;
    listForm?:OfbizList;
    ofbizForm?:OfbizForm;
    fullWidth?:boolean;
    target?:string;
}

export interface ComponentState {
    workSpaceState:string;
    callState?:CallState;
    firstVisit?:Boolean;
    action?:ActionState;
    componentConfig?:ComponentConfig;
    selectedValue?:SelectedValue;
    breadCrumbs?:BreadCrumbData[];
    activeLevel?:number;
    selectedRelation?:Relation;
    selectedMasterDetail?:Relation;
    selectedTask?:ComponentTask;
    outGoingLink?:OutGoingLink;
    //findParameters?:Parameters;
}

export interface SelectedValue{
    /**
     * Event can be view,list,add or edit
     */
    event?:string;
    /**
     * Type is formName/ListName/View
     */
    type:string;
    /**
     * Text value to be used in headers/breadCrumbs etc.
     */
    label?:string;
    /**
     * Data: remoteFormData
     */
    data:RemoteFormData;

}

export interface Segment{
    pathElement:string;
    parameter:string
}

export interface OutGoingLink{
    /**
     * The name of the form to be openend
     */
    target:string;
    /**
     * Whether the link in intra-app or inter-app
     * Intra-app - Same module different component
     * Inter-app - Diffent module 
     */
    targetType:string;
    /**
     * How to open the link.  Dialog/Window or inline
     */
    targetWindow?:string;
    /**
     * Parameters to be passed on to the target
     */
    parameters?:any;
    //linkData:LinkData;
    root?:string;
    /**
     * Parts of the url
     */
    segments?:Segment[];
    /**
     * RemoteFormData to be used in setting the selected value
     */
    remoteFormData?:RemoteFormData
}

export interface BreadCrumbData{
    displayPrefix?:string;
    label?:string;
    labelFieldName?:string; //label from alternative field other than the current
    displayPostfix?:string;
    type?:string;
    level?:number;
    selectedValue?:SelectedValue;
    addFormText?:string;
    editFormText?:string;
}

export enum LoadingState {
    INIT = "INIT",
    LOADING = "LOADING",
    LOADED = "LOADED"
}

export interface ErrorState {
    errorMsg: string;
}

/* export interface Parameters{
    [key:string]:any;
} */

export enum ActionState {
    FIND = "find",
    ADD = "add",
    EDIT = "edit",
    DELETE = "delete",
    LIST = "list",
    VIEW = "view",
    TEST = "test",
    RELATE = "relate",
    LINK = "link",
    MASTERDETAIL = "master-detail",
    CUSTOM = "custom",
    TASKSACTRSLT = "tasks-action-result"
}

export type CallState = LoadingState | ErrorState;